module.exports = __webpack_public_path__ + "img/tablero-instalaciones.138a9c3b.svg";